var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "suspended-warning-container" }, [
    _c("div", { staticClass: "warning-card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "card-info" }, [
          _c("div", { staticClass: "alert-icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 24 24",
                  width: "32",
                  height: "32",
                  stroke: "#e74c3c",
                  "stroke-width": "2",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                _vm._v(" "),
                _c("line", { attrs: { x1: "15", y1: "9", x2: "9", y2: "15" } }),
                _vm._v(" "),
                _c("line", { attrs: { x1: "9", y1: "9", x2: "15", y2: "15" } }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-message" }, [
            _c("h3", [_vm._v(_vm._s(_vm.suspendTitle))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.suspendDescription))]),
            _vm._v(" "),
            _vm.suspendDate
              ? _c("div", { staticClass: "suspend-date" }, [
                  _c("strong", [_vm._v("Askıya Alınma Tarihi:")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatDate(_vm.suspendDate)) +
                      "\n                    "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm.showActions
          ? _c(
              "div",
              { staticClass: "card-actions" },
              [
                _vm.suspendReason === "payment"
                  ? _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.goToBilling },
                      },
                      [
                        _vm._v(
                          "\n                    Ödeme Yap\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { attrs: { ghost: "" }, on: { click: _vm.connectSupport } },
                  [
                    _vm._v(
                      "\n                    Canlı Destek\n                "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.showActions
          ? _c("div", { staticClass: "no-permission-info" }, [
              _c("p", [
                _vm._v(
                  "Bu işlem için yetkiniz bulunmamaktadır. Lütfen site yöneticinizle iletişime geçin veya canlı destek hattımızdan yardım alın."
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "support-action" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "" },
                      on: { click: _vm.connectSupport },
                    },
                    [
                      _vm._v(
                        "\n                        Canlı Destek\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "features-container" }, [
      _c("div", { staticClass: "feature-box" }, [
        _c("div", { staticClass: "feature-icon" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#22272d",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [
              _c("rect", {
                attrs: {
                  x: "1",
                  y: "4",
                  width: "22",
                  height: "16",
                  rx: "2",
                  ry: "2",
                },
              }),
              _vm._v(" "),
              _c("line", { attrs: { x1: "1", y1: "10", x2: "23", y2: "10" } }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Ödeme Sorunu Çözümü")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Birikmiş faturalarınızı ödeyerek ve ödeme bilgilerinizi güncelleyerek hesabınızı tekrar aktifleştirebilirsiniz."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-box" }, [
        _c("div", { staticClass: "feature-icon" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#22272d",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [
              _c("line", { attrs: { x1: "12", y1: "1", x2: "12", y2: "23" } }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Hızlı Çözüm")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Fatura ve ödeme sayfamızdan kolayca hesabınızı yeniden aktifleştirebilirsiniz."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-box" }, [
        _c("div", { staticClass: "feature-icon" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#22272d",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [_c("path", { attrs: { d: "M9 11H1l6-6 6 6M9 17h8l-6 6-6-6" } })]
          ),
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Canlı Destek")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Herhangi bir sorunuz varsa 7/24 canlı destek ekibimiz yardımcı olmaya hazır."
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }